import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="plugin" id="plugin"></a>
    <h1 {...{
      "id": "plugin"
    }}>{`Plugin`}</h1>
    <p>{`Plugin object received in the PluginManager.getPlugins list,
used for IPC(Inter Plugin Communication)`}</p>
    <a name="plugin-id" id="plugin-id"></a>
    <h2 {...{
      "id": "id--string"
    }}>{`id : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get plugin id`}</p>
    <a name="plugin-version" id="plugin-version"></a>
    <h2 {...{
      "id": "version--string"
    }}>{`version : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get plugin version`}</p>
    <a name="plugin-name" id="plugin-name"></a>
    <h2 {...{
      "id": "name--string"
    }}>{`name : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Get plugin name`}</p>
    <a name="plugin-manifest" id="plugin-manifest"></a>
    <h2 {...{
      "id": "manifest--object"
    }}>{`manifest : `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get plugin manifest`}</p>
    <a name="plugin-enabled" id="plugin-enabled"></a>
    <h2 {...{
      "id": "enabled--boolean"
    }}>{`enabled : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get plugin enabled/disabled state`}</p>
    <a name="plugin-showpanel" id="plugin-showpanel"></a>
    <h2 {...{
      "id": "showpanelpanelid"
    }}>{`showPanel(panelId)`}</h2>
    <p>{`Show panel with the given ID. This api may be routed to the host app which can chose to disallow it.
Used for commmunicating with other plugins (IPC : Inter Plugin Communication)
Note: Currently there is no API to hide a panel, panels can be shown but can not be hidden.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>|string`}</inlineCode>{` Resolves with a void if success else returns a rejection message  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`panelId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`id of the panel to be shown`}</td>
        </tr>
      </tbody>
    </table>
    <a name="plugin-invokecommand" id="plugin-invokecommand"></a>
    <h2 {...{
      "id": "invokecommandcommandid-params"
    }}>{`invokeCommand(commandId, ...params)`}</h2>
    <p>{`Invoke command with given ID. This api may be routed to the host app which can chose to disallow it.
Used for commmunicating with other plugins (IPC : Inter Plugin Communication)`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`commandId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`id of the command to be invoked`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...params`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`arguments to be passed to the command entrypoint as defined in the plugin`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      